import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'baf-view-container',
  templateUrl: './view-container.component.html',
  styleUrls: ['./view-container.component.css']
})
export class ViewContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/view-container/view-container.component.ts